export default {
      id: "outline-arrow-down-usage",
      viewBox: "0 0 14 14",
      url: "/" + "img/marilyn-ui.svg#outline-arrow-down",
      toString: function () {
        return this.url;
      }
    }